import { formatInTimeZone } from 'date-fns-tz'
import React from 'react'

import { Tag } from '@/components'
import { StayCommitment } from '@/types/User'

export const StayCommitmentListColumns = [
  {
    Header: 'Date Created',
    accessor: 'createdAt',
    width: 120,
    Cell: function _Cell({ value = '' }: { value: string }) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      try {
        const time = formatInTimeZone(value, timezone, 'MMM d, yyyy')
        return time
      } catch (e) {
        return 'Invalid  Date'
      }
    },
  },
  {
    Header: 'Committed Nights',
    accessor: 'committedNights',
    width: 75,
  },
  {
    Header: 'Early-Termination Fee',
    accessor: 'earlyTerminationFeeType',
    width: 100,
  },
  {
    Header: 'Tags',
    Cell: ({ row }: { row: { original: StayCommitment } }) => {
      const value = row.original || {}

      const isFulfilled = !!value.fulfilledAt
      const isCancelled = !!value.cancelledAt
      const earlyTerminationFeeWaived = !!value.earlyTerminationFeeWaivedAt

      return (
        <div className="flex w-full items-center justify-center">
          {isFulfilled && (
            <Tag className="mr-1 rounded-full text-sm text-tag-green-dark tag-green-light">Fulfilled</Tag>
          )}
          {isCancelled && <Tag className="mr-1 rounded-full text-sm text-tag-red-dark tag-red-light">Cancelled</Tag>}
          {earlyTerminationFeeWaived && (
            <Tag className="rounded-full text-sm text-tag-purple-dark tag-purple-light">Early-Termination Waived</Tag>
          )}
        </div>
      )
    },
  },
]
